module.exports = __webpack_public_path__ + "img/one.2814de22.png";